
export const closeActionItems = [
    // {
    //     dataDialog: "close-dialog",
    //     title: "Lezárás",
    //     dialogTitle: "Számla Lezárása",
    //     canShow: (row) => "TRANSACTION" !== row.closeObjectType,
    //     actionComponent: (props, close) => <ClosePayable {...props} close={close} path={'/api/manualclose/payable'} isClose={true} confirm={"Biztos hogy le szeretnéd zárni?"} comp={<CloseRow {...props} />} />
    // }, {
    //     dataDialog: "close-dialog",
    //     title: "Újranyitás",
    //     dialogTitle: "Számla Újranyitása",
    //     canShow: (row) => "TRANSACTION" !== row.closeObjectType,
    //     actionComponent: (props, close) => <ClosePayable {...props} close={close} path={'/api/manualclose/payable'} isClose={false} confirm={"Biztos hogy újra szeretnéd nyitni?"} comp={<CloseRow {...props} />} />
    // }, {
    //     dataDialog: "close-dialog",
    //     title: "Lezárás",
    //     dialogTitle: "Tranzakció Lezárása",
    //     canShow: (row) => "TRANSACTION" === row.closeObjectType,
    //     actionComponent: (props, close) => <CloseTransaction {...props} close={close} path={'/api/manualclose/transaction'} isClose={true} confirm={"Biztos hogy le szeretnéd zárni?"} comp={<CloseRow {...props} />} />
    // }, {
    //     dataDialog: "close-dialog",
    //     title: "Újranyitás",
    //     dialogTitle: "Tranzakció Újranyitása",
    //     canShow: (row) => "TRANSACTION" === row.closeObjectType && "CLOSED" === row.state,
    //     actionComponent: (props, close) => <CloseTransaction {...props} close={close} path={'/api/manualclose/transaction'} isClose={false} confirm={"Biztos hogy újra szeretnéd nyitni?"} comp={<CloseRow {...props} />} />
    // }
]